import React from 'react'

const MarksCount = ({exam}) => {
    var grandTotal=0;
    
        exam && exam.students.map((item)=>(
            <>
                {item.subjects && item.subjects.map((subject)=>{
                    
                    return (grandTotal+=subject.optedMarks);
                })}
            </>
          ))
    
  return (grandTotal);
}

export default MarksCount